/**
 * Removes all localStorage entries that start with "redo"
 */
export function clearRedoLocalStorage(): void {
  if (typeof localStorage !== "undefined") {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("redo")) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      localStorage.removeItem(key);
    }
  }
}

/**
 * Removes all sessionStorage entries that start with "redo"
 */
export function clearRedoSessionStorage(): void {
  if (typeof sessionStorage !== "undefined") {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("redo")) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      sessionStorage.removeItem(key);
    }
  }
}
